// extracted by mini-css-extract-plugin
module.exports = {"container":"servicing-sign-in_container__BTVwP","button":"servicing-sign-in_button__Ovvrg","text":"servicing-sign-in_text__l8ysg","line":"servicing-sign-in_line__gRgZk"};